import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { experience } from "../../content/timeline";

function Timeline() {
  return (
    <VerticalTimeline>
      {experience.map((role) => (
        <VerticalTimelineElement
          key={`${role.company}-${role.dates}`}
          className="vertical-timeline-element--work timeline-entry"
          contentStyle={{
            backgroundColor: "rgba(0, 0, 0, 0.0)",
          }}
        >
          <h3 className="vertical-timeline-element-title">{role.title}</h3>
          <h4 className="vertical-timeline-element-subtitle">
            {role.company}
            {role.location ? ` · ${role.location}` : ""}
          </h4>
          <p className="timeline-dates">{role.dates}</p>
          <ul className="timeline-highlights">
            {role.highlights.map((highlight) => (
              <li key={highlight}>{highlight}</li>
            ))}
          </ul>
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>
  );
}

export default Timeline;
